import React, { createContext, useReducer, useState } from "react";
import {
  curriculumInitialState,
  courseInitialState,
  hoursInitialState,
} from "../components/300/contexts/initialStates";
import {
  courseReducer,
  curriculumReducer,
} from "../components/300/contexts/reducers";

const CourseContext = createContext();

export function CourseContextProvider({ children }) {
  const [tabState, setTabState] = useState("curriculum");
  const [courseState, courseDispatch] = useReducer(
    courseReducer,
    courseInitialState
  );
  const [curriculumState, curriculumDispatch] = useReducer(
    curriculumReducer,
    curriculumInitialState
  );

  const [hoursState, setHours] = useState({});
  return (
    <CourseContext.Provider
      value={{
        courseState,
        courseDispatch,
        curriculumState,
        curriculumDispatch,
        tabState,
        setTabState,
        hoursState,
        setHours,
      }}
    >
      {children}
    </CourseContext.Provider>
  );
}

export default CourseContext;
